module.exports = "https://cdn.realtymogul.com/static/media/chart_growth.99fd3310.png";